import { useTheme } from '../../theme/useTheme.js';
import { useTranslation } from '../../i18n/useTranslation.js';

function SunIcon() {
  return (<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" /></svg>);
}
function MoonIcon() {
  return (<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" /></svg>);
}

export function ThemeToggle() {
  const { isDark, setThemeChoice } = useTheme();
  const { t } = useTranslation();
  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={() => setThemeChoice(isDark ? 'light' : 'dark')}
      aria-label={isDark ? t('settings.theme.light') : t('settings.theme.dark')}
      title={isDark ? t('settings.theme.light') : t('settings.theme.dark')}
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}
